import React, { useState } from "react";
import { AppBar, Toolbar, Typography, Box, Button, Dialog, styled } from "@mui/material";
import DaalchiniLogo from '../../assets/DaalchiniLogo.png';

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
});

const LocationHeader = () => {




  return (
    <>
      <AppBar position="sticky" sx={{ backgroundColor: "#fae14b", boxShadow: "none" }}>
        <StyledToolbar>
          <Box display="flex" alignItems="center">
            <img
              src={DaalchiniLogo}
              alt="Daalchini Logo"
              style={{ maxHeight: 30, marginRight: 10 }}
            />
          </Box>
   
        </StyledToolbar>
      </AppBar>


    </>
  );
};

export default LocationHeader;
